import { render, staticRenderFns } from "./CantidadDeSuspensionesATratarComponent.vue?vue&type=template&id=4388b412"
import script from "./CantidadDeSuspensionesATratarComponent.vue?vue&type=script&lang=js"
export * from "./CantidadDeSuspensionesATratarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports